import React from "react";
import { observer } from "mobx-react-lite";
import statsImage from "../assets/images/stats.png";
import qrcodeImage from "../assets/images/qrcode.png";
import deskImage from "../assets/images/desk.png";
import wheelImage from "../assets/images/wheel.png";
import monitorImage from "../assets/images/monitor.png";
import phoneImage from "../assets/images/phone.png";
import "./Process.scss";

const Process = observer(() => {
  return (
    <div className="process-page main-content">
      <div className="process-container">
        <h1 className="process-title">Event Day Process</h1>
        <p className="process-description">
          Please follow this process on the day of your event. Use the Pre drive, Check IN, Check OUT, and Post drive survey tabs to follow the process. You can also view your event stats on this page!
        </p>

        {/* Stats Section */}
        <div className="stats-section">
          <img src={statsImage} alt="Event Statistics" className="stats-image" />
        </div>

        {/* Process Flow */}
        <div className="process-flow">
          <div className="process-step">
            <div className="step-icon">
              <img src={qrcodeImage} alt="QR Code" />
            </div>
            <div className="step-text">
              Fill out Pre-Drive survey using the QR code or through a volunteer in the portal
            </div>
          </div>

          <div className="flow-arrow">→</div>

          <div className="process-step">
            <div className="step-icon">
              <img src={deskImage} alt="Check In" />
            </div>
            <div className="step-text">
              Check participants into the event using the check in tab.
            </div>
          </div>

          <div className="flow-arrow">→</div>

          <div className="process-step">
            <div className="step-icon">
              <img src={wheelImage} alt="Test Drive" />
            </div>
            <div className="step-text">
              Direct participants to their test-drive
            </div>
          </div>

          <div className="flow-arrow">→</div>

          <div className="process-step">
            <div className="step-icon">
              <img src={monitorImage} alt="Check Out" />
            </div>
            <div className="step-text">
              Check participants out of the event using the check out tab.
            </div>
          </div>

          <div className="flow-arrow">→</div>

          <div className="process-step">
            <div className="step-icon">
              <img src={phoneImage} alt="Post Drive Survey" />
            </div>
            <div className="step-text">
              Participants will receive an email/text with the post drive survey once they have been checked out.
            </div>
          </div>
        </div>

        {/* Bottom Banner */}
        <div className="process-banner">
          Encourage participants to complete the survey prior to leaving the event. Participants have 24 hours to finish the post drive survey.
        </div>
      </div>
    </div>
  );
});

export default Process;

